// extracted by mini-css-extract-plugin
module.exports = {"footer":"article_footer__DHiPc","divider":"article_divider__Y4dT5"};